import React from 'react';
import { motion } from 'framer-motion';
import { Eye, CheckSquare, Home, ArrowRight, ArrowDown } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 bg-white overflow-hidden" data-id="element-191">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-192">
        <div className="text-center mb-16" data-id="element-193">
          <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900 mb-4" data-id="element-194">
            Imagina esto (de verdad)
          </h2>
          <p className="text-xl text-stone-600 max-w-2xl mx-auto" data-id="element-195">
            Tu hijo se levanta. En vez de que tú seas un altavoz... hay un
            tablero.
          </p>
        </div>

        {/* Steps Visualization */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-20 relative" data-id="element-196">
          {/* Step 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="w-full md:w-1/3 bg-amber-50 border-2 border-amber-200 rounded-2xl p-8 text-center relative z-10" data-id="element-197">
            <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4 text-amber-600" data-id="element-198">
              <Eye className="w-8 h-8" data-id="element-199" />
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-200">
              Ve el tablero
            </h3>
            <p className="text-stone-600" data-id="element-201">
              Sabe qué sigue sin que nadie le diga
            </p>
          </motion.div>

          {/* Arrow Desktop */}
          <div className="hidden md:block text-stone-300" data-id="element-202">
            <ArrowRight className="w-8 h-8" data-id="element-203" />
          </div>
          {/* Arrow Mobile */}
          <div className="md:hidden text-stone-300" data-id="element-204">
            <ArrowDown className="w-8 h-8" data-id="element-205" />
          </div>

          {/* Step 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="w-full md:w-1/3 bg-amber-50 border-2 border-amber-200 rounded-2xl p-8 text-center relative z-10" data-id="element-206">
            <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4 text-amber-600" data-id="element-207">
              <CheckSquare className="w-8 h-8" data-id="element-208" />
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-209">
              Marca lo que hizo
            </h3>
            <p className="text-stone-600" data-id="element-210">Siente logro y avanza solo</p>
          </motion.div>

          {/* Arrow Desktop */}
          <div className="hidden md:block text-stone-300" data-id="element-211">
            <ArrowRight className="w-8 h-8" data-id="element-212" />
          </div>
          {/* Arrow Mobile */}
          <div className="md:hidden text-stone-300" data-id="element-213">
            <ArrowDown className="w-8 h-8" data-id="element-214" />
          </div>

          {/* Step 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="w-full md:w-1/3 bg-amber-50 border-2 border-amber-200 rounded-2xl p-8 text-center relative z-10" data-id="element-215">
            <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4 text-amber-600" data-id="element-216">
              <Home className="w-8 h-8" data-id="element-217" />
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-218">
              Hay secuencia
            </h3>
            <p className="text-stone-600" data-id="element-219">
              Y cuando hay secuencia... hay calma
            </p>
          </motion.div>
        </div>

        {/* Product Reveal */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-amber-400 to-emerald-500 rounded-3xl p-8 md:p-16 text-center text-white shadow-2xl relative overflow-hidden" data-id="element-220">
          <div className="absolute top-0 left-0 w-full h-full bg-white/10 backdrop-blur-[2px] z-0" data-id="element-221"></div>
          <div className="relative z-10" data-id="element-222">
            <p className="text-lg md:text-xl font-medium mb-2 opacity-90" data-id="element-223">
              Por eso existe
            </p>
            <h2 className="text-4xl md:text-6xl font-black mb-6 tracking-tight drop-shadow-md" data-id="element-224">
              Rutinas Visuales sin Gritos
            </h2>
            <p className="text-xl md:text-2xl mb-10 max-w-3xl mx-auto font-medium leading-relaxed" data-id="element-225">
              El sistema visual paso a paso para reducir conflictos diarios y
              lograr cooperación real desde la primera semana.
            </p>

            <div className="max-w-xs mx-auto transform hover:scale-105 transition-transform duration-500" data-id="element-226">
              <img src="https://cdn.magicpatterns.com/uploads/qhpin6YT7a7eK1bRf1jjZb/rutinas_visuales_portada_de_ebook.png" alt="Portada del libro" className="w-full h-auto rounded-xl shadow-2xl border-4 border-white/20" data-id="element-227" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}